export default __webpack_public_path__ + "static/media/undraw_doctor_kw5l.1a88bedf.svg";